import styled from "@emotion/styled/macro";
import { ReactComponent as Favorite } from "../../img/SmallHeart.svg";
import { ReactComponent as EmptyHeart } from "../../img/EmptyHeart.svg";
import { ReactComponent as Bed } from "../../img/Bed.svg";
import { ReactComponent as Shower } from "../../img/Shower.svg";
import { ReactComponent as Ruler } from "../../img/Ruler.svg";
import { HomeCardInterface } from "../screens/SavedHomes/SavedHomes";
import {ISlsOrd} from "../../kova/slsordClient";
import {ThemeColors} from "./GlobalLayout";
import {useUserContext} from "../../context/userContext";

const HomeCardDiv = styled.div`
  flex: 0 0 205px;
  height: 405px;
  width: 205px;
  margin-top: 16px;
  margin-bottom: 16px;
  background: white;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`

const ImgContainer = styled.div`
  height: 200px;
  width: 100%;

  .likeButton {
    margin-top: 9px;
    margin-right: 16px;
  }

  .homeImage {
    transform: rotate(0deg);
    display: flex;
    height: 200px;
    justify-content: space-between;
    background-repeat: no-repeat;
    background-size: cover;
    background-position:center;
  }


  .reserved,.sold {
    background-color: ${ThemeColors.gold};
    color: white;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    margin-top: 8px;
    padding: 8px 16px 8px 16px;
    height: fit-content;
  }
`

const TextArea = styled.div`
  height:205px;
  display:flex;
  flex-direction: column;
  justify-content: flex-end;
  .textArea {
    margin: 16px;
  }

  .textArea div:first-child {
    display: flex;
    justify-content: space-between;
  }

  .textArea div:first-child > div:first-child {
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 4px;
  }
  
  .textArea div:first-child > div:nth-child(2n) {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    margin-top: 3px;
  }

  .textArea > div:nth-child(2n) {
    display: flex;
    justify-content: space-between;
    margin-right:68px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  }

  .graphicDetails {
    margin-top: 32px;
    margin-bottom: 16px;
    margin-left: 16px;
    margin-right: 16px;    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
`

const GraphicContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;

  > svg {
    margin-bottom: 6px;
  }
`

const GraphicImagesContainer = styled.div`
  display: flex;
  justify-content: inherit;
`

const ViewDetails = styled.div`
  align-items: center;
  box-sizing: border-box;
  border-radius: 50px;
  color: var(--secondary-color);
  border: 1.5px solid var(--secondary-color);
  background-color: transparent;
  letter-spacing: 0.05em;
  display: flex;
  justify-content: space-around;
  width: 135px;
  height: 40px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  align-self: center;
  margin-top: 16px;
`

export interface IHomeCardHomeProps {
    isSold?: boolean,
    reservedTo?: number,
    marketingName: string;
    lotStreetAddress?: string;
    price: number;
    bedrooms:string;
    baths: string;
    sqf: string;

}

const HomeCard: React.FC<{
  home: IHomeCardHomeProps
  imageUrl: string,
    isFavorite?: boolean,
  setAsFavorite?: (isFavorite:boolean) => void,
  onClick?: () => void,
  onViewDetails?: () => void
}> = ({
    home,
    imageUrl,
    isFavorite,
    setAsFavorite,
    onClick,
    onViewDetails
  }) => {

    const user = useUserContext();

    const isLoggedIn = user.user !== undefined;
    return (
      <HomeCardDiv onClick={onClick}>
        <ImgContainer>
          <div
            className={home.isSold ? 'homeImage soldHome' : 'homeImage'}
            // className='homeImage'

            style={{ 
              'backgroundImage': `url(${imageUrl})`
            }}
          > 

            {home.isSold && (
              <div className='sold'>
                Sold
              </div>
            )}
              { home.reservedTo !== undefined && home.reservedTo !== 0 && <div className={'reserved'}>Pending Sale</div> }

            {setAsFavorite && isLoggedIn && isFavorite && <Favorite onClick={(ev) => { setAsFavorite && setAsFavorite(false); ev.preventDefault(); }} className='likeButton'/> }
              { setAsFavorite && isLoggedIn && !isFavorite && <EmptyHeart onClick={(ev)=> { setAsFavorite && setAsFavorite(true); ev.preventDefault(); }} className='likeButton'/> }


          </div>
        </ImgContainer>
        <TextArea>
          <div className='textArea'>
            <div className='headlineDetails'>
              <span className={"body1"}>
                  { home.marketingName }
              </span>
              {!home.isSold && (
                <span className={"body3"}>
                    { home.price > 0 && ("$" + home.price)}
                </span>
              )}

            </div>
            <div>
                { home.lotStreetAddress }
            </div>
          </div>
          <div className='graphicDetails'>
            <GraphicImagesContainer>
              <GraphicContainer>
                <Bed />
                {home.bedrooms}
              </GraphicContainer>
              <GraphicContainer>
                <Shower />
                {home.baths}
              </GraphicContainer>
              <GraphicContainer>
                <Ruler />
                {home.sqf}
              </GraphicContainer>
            </GraphicImagesContainer>
            {(!home.isSold || true) && (
              <ViewDetails onClick={onViewDetails}>
                View Details
              </ViewDetails>
            )}
          </div>
          
        </TextArea>
      </HomeCardDiv>
    )
}
export default HomeCard;